module.exports = __webpack_public_path__ + "img/permisos-block.cde75894.svg";